const global = globalThis || this || self;

export { global };
